import { render, staticRenderFns } from "./PendingReview.vue?vue&type=template&id=15776048&scoped=true&"
import script from "./PendingReview.vue?vue&type=script&lang=js&"
export * from "./PendingReview.vue?vue&type=script&lang=js&"
import style0 from "./PendingReview.vue?vue&type=style&index=0&id=15776048&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15776048",
  null
  
)

export default component.exports